
export const accessControl = {
  ENTITY_TYPE: {
    TRIP: 1,
    CUSTOMER: 2,
    PARTNER: 3,
    TRUCK: 4,
    CUSTOMER_KYC: 5,
    PARTNER_KYC: 6,
  },

  REQUEST_STATUS: {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
  },
};